import { FC, useEffect } from "react";
import { UserReverifyModalHeader } from "./UserReverifyModalHeader";
import { UserReverifyModalBody } from "./UserReverifyModalBody";

interface Props {
  onSuccess: () => void;
  onCancel: () => void;
}

export const UserReverifyModal: FC<Props> = ({ onSuccess, onCancel }) => {
  useEffect(() => {
    document.body.classList.add("modal-open");
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_reverify"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-600px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <UserReverifyModalHeader onCancel={onCancel} />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-10 my-2">
              <UserReverifyModalBody onSuccess={onSuccess} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};
